var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ul',{staticClass:"nav nav-tabs",attrs:{"role":"tablist"}},[_vm._t("content",null,{"active":_vm.selected})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }